import React from 'react'
import ToolBoxListItem from './ToolBoxListItem'

export default class extends React.Component {
  
  onClickHandler = (e, id) => {
    this.props.itemOnClick(e, id);
  }

  render() {
    return (
      <ul className="c-toolbox-list">
      {
        this.props.items.map((item, i) => (
          <ToolBoxListItem 
            id={item.id}
            key={item.id}
            label={item.label}  
            onClick={this.onClickHandler} 
            activated={this.props.activatedItem}
            popOverPosition={this.props.popOverPosition}   
          />
        ))
      }
      </ul>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/ToolBoxList.jsx